import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { Toaster } from 'sonner';
import AdminLayout from './components/Layout/AdminLayout';
import Dashboard from './pages/Dashboard/Dashboard';
import Events from './pages/Events/Events';
import ChatTest from './pages/ChatTest/ChatTest';
import Users from './pages/Users/Users';
import AppUsers from './pages/AppUsers/AppUsers';
import Guardrails from './pages/Guardrails/Guardrails';
import BehavioralPrompts from './pages/BehavioralPrompts/BehavioralPrompts';
import Documents from './pages/Documents/Documents';
import UserStatistics from './pages/Statistics/UserStatistics';
import CostAnalytics from './pages/CostAnalytics/CostAnalytics';
import EventLandingPage from './pages/LandingPage/EventLandingPage';
import EventChatPage from './pages/LandingPage/EventChatPage';
import Conversations from './pages/Conversations/Conversations';
import Feedback from './pages/Feedback/Feedback';
import CallbackRequests from './pages/CallbackRequests/CallbackRequests';
import Backup from './pages/Backup/Backup';
import SentimentAnalysis from './pages/SentimentAnalysis/SentimentAnalysis';
import Settings from './pages/Settings/Settings';
import Allowlist from './pages/Allowlist/Allowlist';
import Login from './pages/Login/Login';
import AITraces from './pages/AITraces/AITraces';
import SelfImprovement from './pages/SelfImprovement/SelfImprovement';
import NegativeFeedback from './pages/SelfImprovement/NegativeFeedback';
import PromptManagement from './pages/PromptManagement/PromptManagement';
import AIModels from './pages/AIModels/AIModels';
import AIModuleMappings from './pages/AIModuleMappings/AIModuleMappings';
import EmailVerification from './pages/EmailVerification/EmailVerification';
import ProtectedRoute from './components/ProtectedRoute';
import { AuthProvider } from './contexts/AuthContext';

const App: React.FC = () => {
  return (
    <AuthProvider>
      <Toaster position="top-right" richColors />
      <Router>
          <Routes>
            {/* Public Routes - Event Landing Pages */}
            <Route path="/event/:eventId" element={<EventLandingPage />} />
            <Route path="/event/:eventId/chat" element={<EventChatPage />} />

            {/* Login Route */}
            <Route path="/login" element={<Login />} />

            {/* Protected Admin Routes */}
            <Route path="/admin" element={
              <ProtectedRoute>
                <AdminLayout />
              </ProtectedRoute>
            }>
              <Route index element={<Dashboard />} />
              <Route path="events" element={<Events />} />
              <Route path="chat-test" element={<ChatTest />} />
              <Route path="users" element={<Users />} />
              <Route path="app-users" element={<ProtectedRoute requireAdmin><AppUsers /></ProtectedRoute>} />
              <Route path="guardrails" element={<Guardrails />} />
              <Route path="behavioral-prompts" element={<BehavioralPrompts />} />
              <Route path="documents" element={<Documents />} />
              <Route path="user-statistics" element={<UserStatistics />} />
              <Route path="cost-analytics" element={<CostAnalytics />} />
              <Route path="conversations" element={<Conversations />} />
              <Route path="feedback" element={<Feedback />} />
              <Route path="callback-requests" element={<CallbackRequests />} />
              <Route path="sentiment-analysis" element={<SentimentAnalysis />} />
              <Route path="backup" element={<Backup />} />
              <Route path="ai-traces" element={<ProtectedRoute requireAdmin><AITraces /></ProtectedRoute>} />
              <Route path="self-improvement" element={<SelfImprovement />} />
              <Route path="self-improvement/negative-feedback" element={<NegativeFeedback />} />
              <Route path="prompts" element={<ProtectedRoute requireAdmin><PromptManagement /></ProtectedRoute>} />
              <Route path="ai-models" element={<ProtectedRoute requireAdmin><AIModels /></ProtectedRoute>} />
              <Route path="ai-module-mappings" element={<ProtectedRoute requireAdmin><AIModuleMappings /></ProtectedRoute>} />
              <Route path="email-verification" element={<ProtectedRoute requireAdmin><EmailVerification /></ProtectedRoute>} />
              <Route path="allowlist" element={<Allowlist />} />
              <Route path="settings" element={<Settings />} />
            </Route>

            {/* Default redirect */}
            <Route path="/" element={<Navigate to="/admin" replace />} />
          </Routes>
        </Router>
    </AuthProvider>
  );
};

export default App;


